// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__srYRE","boxChecked":"Checkbox_boxChecked__FHJ6G"};